import { Whisper, Popover } from 'rsuite';
import React from 'react';
import type { WhisperProps } from 'rsuite/esm/Whisper/Whisper';

type Props = {
  trigger?: WhisperProps['trigger'];
  placement?: WhisperProps['placement'];
  controlId: string;
  speakerContent: React.ReactNode;
  children: React.ReactElement | ((props: any, ref: any) => React.ReactElement);
};

function CustomPopover({
  children,
  speakerContent,
  controlId,
  trigger,
  placement,
}: Props) {
  return (
    <>
      <Whisper
        trigger={trigger}
        placement={placement}
        controlId={controlId}
        speaker={<Popover>{speakerContent}</Popover>}
      >
        {children}
      </Whisper>
    </>
  );
}

export default CustomPopover;
